type GetShortcutKeyParams = {
    isMacOs: boolean;
    isWindows: boolean;
    locale?: string;
};

export function getShortcutKey({ isMacOs, isWindows, locale }: GetShortcutKeyParams) {
    if (isMacOs) {
        return '⌘ K';
    }

    const isGermanLocale = locale?.toLowerCase().startsWith('de') ?? false;

    if (isWindows && isGermanLocale) {
        return 'Strg K';
    }

    return 'Ctrl K';
}
